import { useUploadImageMutation } from "@garther/query-hooks";
import { getErrorMessage, toast, useI18n } from "@garther/ui/libs";

export function useUploadImage() {
  const { t } = useI18n();
  return useUploadImageMutation({
    onError: (error) => toast.error(getErrorMessage(error) || t("common.error.tryAgain"))
  });
}
